import {arrayRange, formatErrorMessage} from '../helpers/common'
import {getSubmenuTextById} from '../helpers/menu'
import {Record} from 'immutable'
import {
    answerT1Record,
    setQuestionFormErrors,
    QUESTION_CHANGE_QUESTION_DATA,
    QUESTION_CHANGE_QUESTION_STATISTIC_ANSWER,
    QUESTION_STATUSES,
    formErrorsRecord,
    questionSelector,
    changeQuestionsStatuses,
    questionsMassOpenState
} from './questions'
import Underscore from 'underscore'


export const MIN_ANSWERS_COUNT = 4
export const MAX_ANSWERS_COUNT = 10

export const CAT_PREFIX = 'cat_'
export const SUBCAT_PREFIX = 'subcat_'

export const DISABLED = 0
export const ENABLED = 1
export const TEMP = 4

export const _getId = (_, id) => id
export const _getIds = (_, ids) => ids
export const _trashedScopeCB = item => item && item.status !== DISABLED
export const _isTrashed = item => {
    return item && item.status === DISABLED
}
export const _isTemp = item => item && item.status === TEMP

export const _entities = entitiesMap => entitiesMap.valueSeq().toArray().filter(_trashedScopeCB)
export const _entitiesGroup = (entitiesMap, entitiesIds) => entitiesIds.map(id => entitiesMap.get(id)).filter(entity => entity).filter(_trashedScopeCB)
export const _entitiesWithTrashed = entitiesMap => entitiesMap.valueSeq().toArray()

export const _getEntity = (entitiesMap, entityId) => {
    const entity = entitiesMap.get(entityId)
    return _trashedScopeCB(entity) ? entity : undefined
}
export const _getEntityWithTrashed = (entitiesMap, entityId) => entitiesMap.get(entityId)
export const _getEntityWithTemp = (entitiesMap, entityId) => entitiesMap.get(entityId)

const __isAnswerKey = key => key && typeof key === 'string' && key.indexOf('answer_') === 0

export const restructureCategories = (catSubcat) => {
    return catSubcat.reduce((acc, curr) => {
        const {id, subcategoriesWithTrashed} = curr
        const _subcat = subcategoriesWithTrashed.map(s=>({...s,parent_id:id}))
        return [
            ...acc,
            ..._subcat,
            curr,
        ]
    }, [])
}

export const adjustEntitiesFieldsType = entities => entities.map(({created_at, updated_at, status, ...rest}) => {
    if (typeof created_at !== 'undefined') created_at = +created_at
    if (typeof updated_at !== 'undefined') updated_at = +updated_at
    if (typeof status !== 'undefined') status = +status

    return {
        ...rest,
        created_at,
        updated_at,
        status,
    }
})

export const getRenderAnswers = (question, answersCount) => {
    const answers = __getAnswers(question.answerT1);
    const statistic = question.statistic;
    
    
    let total_answers = 0;
    if(statistic && typeof statistic == 'object'){
        Object.keys(statistic).forEach(key => {
            if(key.indexOf('answer_') > -1){
                total_answers += parseInt(statistic[key]);
            }
        })
    }


    let answer_index = -1;
    let total_procent = 0;

    let renderAnswers = answers.map((answer, i) => {
        answer.procent = 0;
        if(statistic && statistic[`answer_${i+1}`] && total_answers && parseInt(statistic[`answer_${i+1}`]) > 0) {
            const pr = 100/total_answers;
            answer.procent = Math.floor(pr * statistic[`answer_${i+1}`] * 100 )/100;
            answer_index = i;
            total_procent += answer.procent;
        }
        return {...answer}
    })



    if(total_procent > 0 && answer_index > -1){
        total_procent = Math.floor(total_procent*100)/100;
        renderAnswers[answer_index].procent = renderAnswers[answer_index].procent + (100 - total_procent);
    }


    let labels = arrayRange(10, 65)
    for (let i = answers.length; i < answersCount; i++) {
        let labelIndex = renderAnswers.length;
        renderAnswers = [
            ...renderAnswers,
            {
                text : "", 
                label : String.fromCharCode(labels[labelIndex]), 
                isCorrect : false, 
                storeKey : `answer_${i+1}`,
                // procent: total_procent TODO: перевірити
            }
        ]
    }
    return renderAnswers
}

const __getAnswers = answerT1 => {
    let answers = []
    let charCodes = arrayRange(10, 65)
    if (!Record.isRecord(answerT1)) answerT1 = new answerT1Record({...answerT1})

    let __arr = []
    answerT1.toSeq().forEach((value, key) => {
        if (__isAnswerKey(key)) {
            // let labelIndex = answers.length
            let text = answerT1[key]
            // let label = String.fromCharCode(charCodes[labelIndex])
            let isCorrect = key === answerT1.correct_answer
            __arr = [
                ...__arr,
                {text, /*label, */isCorrect, storeKey : key},
            ]
        }
        return true
    })
    let greaterHasValue = false
    let storeKeysFromMinLength = populateStoreKeysFromMinLength()
    // __arr = __arr.sort((a, b) => {
    //     let {storeKey : a_storeKey} = a
    //     let {storeKey : b_storeKey} = b
    //     let _a_id = a_storeKey.split("_")[1]
    //     let _b_id = b_storeKey.split("_")[1]
    //     return _b_id - _a_id
    // })

    for (let i = __arr.length - 1; i >= 0; i--) {
        let current = __arr[i]
        let {storeKey, text : value, isCorrect} = current
        if (!storeKeysFromMinLength.includes(storeKey) && value) {
            greaterHasValue = true
        }

        if (storeKeysFromMinLength.includes(storeKey) || value || isCorrect || greaterHasValue) {
            answers = [
                ...answers,
                current
            ]
        }
    }


    return answers.reverse().map((answer, index) => ({
        ...answer,
        label : String.fromCharCode(charCodes[index])
    }))
}

export const getAnswers = (answerT1) => {
    let answers = []
    let labels = arrayRange(10, 65)
    if (!Record.isRecord(answerT1)) answerT1 = new answerT1Record({...answerT1})
    let storeKeysFromMinLength = populateStoreKeysFromMinLength()
    answerT1.toSeq().forEach((value, key) => {
        if (__isAnswerKey(key) && (storeKeysFromMinLength.includes(key) || value)) {
            let labelIndex = answers.length
            let text = answerT1[key]
            let label = String.fromCharCode(labels[labelIndex])
            let isCorrect = key === answerT1.correct_answer
            answers = [
                ...answers,
                {text, label, isCorrect, storeKey : key}
            ]
        }
        return true
    })
    return answers
}

export const getAnswersForSave = (answerT1) => {
    let result = {}
    if (!Record.isRecord(answerT1)) answerT1 = new answerT1Record({...answerT1})
    answerT1.toSeq().forEach((value, key) => {
        if (__isAnswerKey(key)) {
            result = {
                ...result,
                [key] : Underscore.escape(value),
            }
        }
        return true
    })
    return result
}

export const populateStoreKeysFromMinLength = () => {
    let result = []
    for (let i = 0; i < MIN_ANSWERS_COUNT; i++) {
        result = [...result, `answer_${i + 1}`]
    }
    return result
}

export const canIncrementAnswers = (answers) => answers.every(answer => !!answer.text) && answers.length < MAX_ANSWERS_COUNT

export const populateLastSavedAnswers = (answerT1) => {
    let result = {}
    for (let key in answerT1) {
        if (__isAnswerKey(key) || key === 'correct_answer') {
            result = {
                ...result,
                [`_ls_${key}`] : answerT1[key],
            }
        }
    }
    return result
}

export const decodeAnswers = (answerT1) => {
    let result = {...answerT1}
    for (let key in answerT1) {
        if (__isAnswerKey(key)) {
            result = {
                ...result,
                [key] : Underscore.unescape(answerT1[key]),
            }
        }
    }
    return result
}

export const isAnswersSame = (answerT1) => {
    let isSame = true
    if (!Record.isRecord(answerT1)) answerT1 = new answerT1Record({...answerT1})
    answerT1.toSeq().forEach((value, key) => {
        if (__isAnswerKey(key) || key === 'correct_answer') {
            if (value !== answerT1[`_ls_${key}`]) return isSame = false // return false in immutable forEach is like a break in for in loop
        }
        return true
    })
    return isSame
}

export const getFilledAnswersCount = (answerT1) => {
    let answers = getAnswers(answerT1)
    return answers.reduce((acc, curr) => {
        if (!!curr.text) acc += 1
        return acc
    }, 0)
}

export const checkQuestionBeforeSave = (question) => {
    let {body, _ls_body, description, _ls_description, answerT1, status, _ls_status, form : {errors}} = question
    const {correct_answer} = answerT1

    let hasError
    if (!Record.isRecord(errors)) errors = new formErrorsRecord({...errors})
    errors.toSeq().forEach((value, key) => {
        if (value.length) {
            hasError = true
            return false
        }
        return true
    })

    // TODO

    if (hasError) return false

    // TODO

    if (!correct_answer) return false

    // TODO

    if (getFilledAnswersCount(answerT1) < MIN_ANSWERS_COUNT) return false

    let isNotChanged = true
    if (body !== _ls_body) isNotChanged = false
    if (description !== _ls_description) isNotChanged = false
    if (!isAnswersSame(answerT1)) isNotChanged = false
    if (status !== _ls_status) isNotChanged = false

    // TODO

    if (isNotChanged) return false

    return true
}

export const sortQuestionsCB = ({created_at : aCreatedAt, isNewForm : aIsNewForm}, {created_at : bCreatedAt, isNewForm : bIsNewForm}) => {
    if (aIsNewForm) return 1
    if (bIsNewForm) return -1
    return aCreatedAt - bCreatedAt
}

export const handleQuestionSaveError = (params) => {
    const {dispatch, questionId, message, errorKey : key = 'backend'} = params
    switch (true) {
        case typeof message === 'string' : {
            dispatch(setQuestionFormErrors({questionId, errorsData : [{key, value : [message]}]}))
            break
        }
        case Array.isArray(message) : {
            dispatch(setQuestionFormErrors({questionId, errorsData : [{key, value : [...message]}]}))
            break
        }
        case typeof message === 'object' && typeof message.message !== 'undefined' : {
            dispatch(setQuestionFormErrors({questionId, errorsData : [{key, value : [message.message]}]}))
            break
        }
        case typeof message === 'object' : {
            let backendErrors = []
            for (let key in message) {
                backendErrors = [
                    ...backendErrors,
                    message[key]
                ]
            }
            dispatch(setQuestionFormErrors({questionId, errorsData : [{key, value : backendErrors}]}))
            break
        }
        case !message : {
            dispatch(setQuestionFormErrors({questionId, errorsData : [{key, value : ["Form wasn't updated. No message from server"]}]}))
            break
        }
        default : {
            dispatch(setQuestionFormErrors({questionId, errorsData : [{key, value : ["Form wasn't updated. No message from server"]}]}))
            break
        }
    }
}

export const handleUpdateLastSavedQuestionData = (params) => {
    const {dispatch, body, description, difficulty, status, questionId} = params
    let questionData = [
        {key : 'body', value : body},
        {key : '_ls_body', value : body},
        {key : "description", value : description},
        {key : "_ls_description", value : description},
        {key : "status", value : status},
        {key : "_ls_status", value : status},
        {key : "difficulty", value : difficulty},
        {key : "_ls_difficulty", value : difficulty}
    ]
    dispatch({
        type : QUESTION_CHANGE_QUESTION_DATA,
        payload : {
            questionId,
            questionData,
        }
    })
    return questionData
}
export const changeQuestionStatisticAnswer = (params) => {
    const {dispatch, statistic, questionId} = params
    let questionData = [
        {key : 'statistic', value : statistic}
    ]
    dispatch({
        type : QUESTION_CHANGE_QUESTION_STATISTIC_ANSWER,
        payload : {
            questionId,
            questionData,
        }
    })
    return questionData
}

export const getAnswersData = (params) => {
    const {correct_answer, answersForSave} = params
    let answersData = [
        {key : "correct_answer", value : correct_answer},
        {key : "_ls_correct_answer", value : correct_answer}
    ]
    for (let key in answersForSave) {
        answersData = [
            ...answersData,
            {key, value : answersForSave[key]},
            {key : `_ls_${key}`, value : answersForSave[key]},
        ]
    }
    return answersData
}

/*
* categories and subcategories are in different DB tables
* */
export const addCatSubcatPrefix = entities => entities.map(entity => ({
    ...entity,
    id : (entity.parent_id ? setPrefixToCatSubcatId(entity.id, true) : setPrefixToCatSubcatId(entity.id, false)),
    parent_id : (entity.parent_id ? setPrefixToCatSubcatId(entity.parent_id, false) : entity.parent_id),
}))
export const setPrefixToCatSubcatId = (id, isSubcat) => isSubcat ? `${SUBCAT_PREFIX}${id}` : `${CAT_PREFIX}${id}`
export const removePrefixCatSubcatId = id => id.indexOf(SUBCAT_PREFIX) !== -1 ? id.slice(SUBCAT_PREFIX.length) : id.slice(CAT_PREFIX.length)

export const prepareNewQuestionForStore = params => { // TODO rfc use getNewQuestionFromGetRepsonse
    const {responseQuestion, answersData, body, description, subjectId, token} = params
    const {id : responseId, created_at, updated_at, difficulty, statistic, answ_state, expl_state, comment_state, category_id, subcategory_id, status, source_id, labels, comments} = responseQuestion
    let answerT1 = answersData.reduce((acc, curr) => ({...acc, [curr.key]:curr.value}), {})
    const _cat_subcat = !!+subcategory_id ? {category_id : setPrefixToCatSubcatId(subcategory_id, true)} : {category_id : setPrefixToCatSubcatId(category_id, false)}
    let newQuestion = {
        id : responseId,
        ..._cat_subcat,
        created_at : +created_at,
        updated_at : +updated_at,
        answerT1,
        answersCount : Math.max(getFilledAnswersCount(answerT1), MIN_ANSWERS_COUNT),
        answ_state,
        expl_state,
        comment_state,
        body,
        difficulty,
        labels,
        comments,
        statistic,
        description,
        source_id,
        subject_id : subjectId,
        status : +status,
        _ls_status : +status,
        _ls_body : body,
        _ls_description : description,
    }
    if(token){
        newQuestion.token = token;
    }
    return newQuestion
}

export const getNewQuestionFromGetRepsonse = params => {
    const {question, subjectId} = params

    let {id, question : body, difficulty, statistic, description, category_id, subcategory_id, labels, token, comments, created_at, updated_at, answerT1, answ_state = 1, expl_state = 1, comment_state, status = QUESTION_STATUSES[2].status, source_id, additional = false} = question
    answerT1 = answerT1 ?
        {
            ...decodeAnswers(answerT1),
            ...populateLastSavedAnswers(decodeAnswers(answerT1)),
        } :
        {}
    const _cat_subcat = !!+subcategory_id ? {category_id : setPrefixToCatSubcatId(subcategory_id, true)} : {category_id : setPrefixToCatSubcatId(category_id, false)}

    let objX =  {
        id,
        body : body,
        _ls_body : body,
        description : description,
        _ls_description : description,
        ..._cat_subcat,
        created_at : +created_at,
        updated_at : +updated_at,
        answerT1,
        answersCount : Math.max(getFilledAnswersCount(answerT1), MIN_ANSWERS_COUNT),
        answ_state : +answ_state,
        expl_state : +expl_state,
        comment_state : +comment_state,
        status : +status,
        _ls_status : +status,
        source_id,
        labels,
        token,
        comments,
        difficulty: +difficulty,
        statistic: statistic,
        subject_id : subjectId,
    }
    if(additional){
        objX.additional = additional;
    }
    return objX;
}

export const getSubjectIdFromTrashResponse = questionResponse => {
    const {category : {branch_id : subjectId} = {}} = questionResponse
    return subjectId
}

export const normalizeCategories = ({categories, subjectId}) => addCatSubcatPrefix(adjustEntitiesFieldsType(restructureCategories(categories))).map(entity => ({...entity, subject_id : subjectId,}))










export const massQuestionsStatusKeysChangeThen = ({questionNotFoundError, submenuId, ...rest}) => response => {
    const {errcode, message, payload = []} = response
    if (errcode !== 200 && (questionNotFoundError && message !== "Questions not found")) {
        let submenuText = getSubmenuTextById(submenuId)
        throw new Error(formatErrorMessage(message, submenuText ? `Fail to "${submenuText}"` : 'Fail. Something went wrong.'))
    }
    handleDispatchMassQuestionStatusesChange({submenuId, payload, ...rest})
}

export const handleDispatchMassQuestionStatusesChange = ({submenuId, getState, dispatch, statusKey, status, payload}) => {
    let state = getState()

    if (statusKey === "status") {
        let changeData = []
        payload.forEach(({id : questionId}) => {
            let question = questionSelector(state, questionId)
            if (!question) return
            changeData = [
                ...changeData,
                {questionId, status}
            ]
        })
        dispatch(changeQuestionsStatuses({
            changeData,
        }))
    } else if (["answ_state", "expl_state", "comment_state"].includes(statusKey)) {
        let changeData = []

        payload.forEach(({id : questionId}) => {
            let question = questionSelector(state, questionId)
            if (!question) return

            changeData = [
                ...changeData,
                {questionId, toggleKey : statusKey, toggleValue : status}
            ]
        })

        dispatch(questionsMassOpenState({
            changeData,
        }))
    }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/_utils.js